import { useQuery } from '@tanstack/react-query';
import { getApiUrl, handleFetchResponse } from '../shared/utils/api';

export function useFindDev() {
  const query = useQuery({
    queryKey: ['find-simulation-dev'],
    enabled: false,
    queryFn: async () => {
      const data = await handleFetchResponse(fetch(getApiUrl(`energia-solar/v2/develop-entry`)));
      return data;
    },
    retry: false,
    initialData: {
      token: '',
      data: {},
    },
  });

  return query;
}
